import "./Carousel.css";

const Carousel = ({ logos }) => {
  return (
    <div className="carousel-container">
      <div className="carousel-track">
        {logos.map((logo, index) => (
          <div key={index} className="carousel-item">
            <img src={logo.src} alt={logo.alt} className="carousel-logo" />
          </div>
        ))}
        {/* Duplicate logos for seamless loop effect */}
        {logos.map((logo, index) => (
          <div key={`duplicate-${index}`} className="carousel-item">
            <img src={logo.src} alt={logo.alt} className="carousel-logo" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
